export default __webpack_public_path__ + "static/media/widget-img.cc77a9b7.png";